import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LogoFooter from '../../../assets/images/logo-footer.svg';
import BgFooter from '../../../assets/images/bg-footer.png';
import Time from '../../../assets/images/time.png';
import Address from '../../../assets/images/address.png';
import Phone from '../../../assets/images/phone.png';
import { useNavigate } from 'react-router-dom';

function AppFooter() {

  const navigate = useNavigate();
  const [isMaintance, setIsMaintance] = useState(false);

  useEffect(() => {
    setIsMaintance(
      window.location.href.includes('?open=register') && process.env.REACT_APP_MAINTANCE_MODE === "1"
    );
  }, []);

  return (
    <>
      {isMaintance && <div className="flex justify-center items-center fixed top-0 left-0 z-[999999] bg-[rgba(0,0,0,0.4)] w-full h-full px-8">
        <div className='w-full text-center bg-white rounded-[38px] h-auto px-7 py-5'>
          <p className="text-[#707070] text-left">為提供更好的貸款服務體驗，KM信貸將進行內部系統升級，即日起暫停私人貸款申請服務，直至另行通知。如有任何查詢，請於辦公時間內致電客戶服務熱線3700 4488。不便之處，敬請原諒。</p>
          <button onClick={() => { navigate('/') }} type="submit" className="rounded-full mt-5 text-white text-sm bg-[#036EB2] px-14 py-2">確定</button>
        </div>
      </div>}
      <div className="text-primary2 p-5 pt-20" style={{ backgroundImage: `url(${BgFooter})` }}>
        <div className="flex items-center justify-center mb-10 lg:mt-12">
          <a href="https://www.facebook.com/kmcredit.hk/">
            <FontAwesomeIcon className="mx-4" icon={['fab', 'facebook']} size="2x" />
          </a>
          <a href="https://www.instagram.com/kmcredit_hk">
            <FontAwesomeIcon className="mx-4" icon={['fab', 'instagram']} size="2x" />
          </a>
          <a href="https://www.youtube.com/channel/UCrz9FiwbVAvfrFd7wJ0arqA">
            <FontAwesomeIcon className="mx-4" icon={['fab', 'youtube']} size="2x" />
          </a>
          <a href="https://www.linkedin.com/company/km-international-asia/?viewAsMember=true%20">
            <FontAwesomeIcon className="mx-4" icon={['fab', 'linkedin']} size="2x" />
          </a>
        </div>
        <div className="flex justify-center lg:items-center flex-col w-full">
          <div className="flex mt-3 text-sm">
            <div className="pt-1">
              <img style={{ width: 21 }} src={Time} alt="" />
            </div>
            <div className="pl-2 leading-5">
              星期一至五&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：早上9時至下午6時 <br />
              星期六, 日及公眾假期&nbsp;：休息
            </div>
          </div>
          <div className="flex mt-3 text-sm">
            <div className="pt-1">
              <img style={{ width: 21 }} src={Address} alt="" />
            </div>
            <div className="pl-2 leading-5">
              <p>香港九龍尖沙咀麼地道67號半島中心10樓1013室</p>
            </div>
          </div>
          <div className="flex mt-3 text-sm">
            <div className="pt-1">
              <img style={{ width: 21 }} src={Phone} alt="" />
            </div>
            <div className="pl-2 leading-5">
              <p>(852) 3700 4488</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center mt-5">
          <img src={LogoFooter} alt="" className="w-48 mb-4" />
          <p className="text-xs">Brand under KM International (Asia) Co., Limited.</p>
        </div>
      </div>
      <div className="py-2 text-white" style={{ backgroundColor: '#6887bb' }}>
        <p className="text-center my-4 text-3xl px-2">忠告：借錢梗要還，咪俾錢中介</p>
        <p className="text-center text-lg">
          投訴熱線 : 3700 4499 <br />
          放債人牌照號碼 : 306/2026
          <br />
        </p>
        <p className="text-xs text-center mt-6">Copyright © KM International (Asia) Co., Limited</p>
      </div>
    </>
  );
}

export default AppFooter;
